module.exports = __webpack_public_path__ + "static/media/delicious.68f14763.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/icons/delicious.svg
// module id = 2725
// module chunks = 7